export const IdStatus = {
  NAO_PROGRAMADA: 1,
  PROGRAMADA: 2,
  PARALISADA: 5,
  FORA_ATENDIMENTO: 13,
  PENDENTE: 14,
  REPROGRAMADA: 15,
  AGENDAMENTO_NAO_EFETIVADO: 27,
  AGENDAMENTO_VENCIDO: 28,
  PLANEJADA: 29,
  BLOQUEADA_PELA_COPASA: 30
} as const;

export const TamanhoAnexo = {
  MAX_SIZE: 4194304
} as const;